import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';

export function useDownloadOTPPdf() {
    const { t } = useTranslation();

    return useMutation<Blob, AppMedError, { id: number; language: string; planName?: string }>({
        mutationKey: [QueryKeys.otp, 'downloadPdf'],
        mutationFn: async ({ id, language }) => {
            return await OTPApi.downloadOTPPdf(id, language);
        },
        onSuccess: (blob, { planName }) => {
            const filename = `OTP_${planName?.replace(/\s+/g, '_') ?? 'Plan'}_${new Date().toISOString().split('T')[0]}.pdf`;
            OTPApi.downloadPdfFile(blob, filename);

            notifications.show({
                title: t('otp.notifications.downloadPdfSuccess.title'),
                message: t('otp.notifications.downloadPdfSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.notifications.downloadPdfError.title'),
                message: error?.message || t('otp.notifications.downloadPdfError.message'),
                color: 'red',
            });
        },
    });
}
